/**
 * Utility for reading/writing hash-based URL query parameters.
 * Enables link sharing across all pages (Search, Redrive, KeyMaster).
 */
export class HashParams {
  static parse(): URLSearchParams {
    const hash = window.location.hash;
    if (!hash.includes("?")) {
      return new URLSearchParams();
    }
    return new URLSearchParams(hash.split("?")[1]);
  }

  static get(key: string): string | null {
    return this.parse().get(key);
  }

  static update(basePath: string, params: Record<string, string>): void {
    const filtered = Object.entries(params).filter(([, v]) => v !== "");
    if (filtered.length === 0) {
      window.history.replaceState(null, "", basePath);
      return;
    }
    const search = new URLSearchParams(filtered);
    window.history.replaceState(null, "", `${basePath}?${search}`);
  }
}
